import React from 'react'
import PropTypes from 'prop-types'
import styled, { css } from 'styled-components'
import kebabCase from 'lodash/kebabCase'
import Icon from 'components/common/Icon/Icon'
import Text from 'components/common/Text/Text'
import Mixin from 'components/common/Mixin'
import { dynamicDataAttribute } from 'helpers/utils'
import { ServiceIcon } from 'components/common/ServiceIcon'

const ServicesDrawerTitle = ({
  expanded,
  title,
  expandedTitle,
  drawerIcon,
  altIcon,
  serviceDrawer,
  numberOfSelectedServices,
  isPreExpand
}) =>
  <div>
    {
      serviceDrawer ?
        <StyledServiceIcon
          { ...dynamicDataAttribute(`category-${kebabCase(title)}-icon`) }
          iconName={ drawerIcon }
          condition={ expanded || !!numberOfSelectedServices || isPreExpand } /> :
        <StyledIcon
          asset={ drawerIcon }
          alternative={ altIcon }
          condition={ expanded || isPreExpand } />
    }
    <Heading>
      {
        expanded ?
          expandedTitle :
          `${title}${numberOfSelectedServices ? ` (${numberOfSelectedServices})` : ''}`
      }
    </Heading>
  </div>

export default ServicesDrawerTitle

ServicesDrawerTitle.propTypes = {
  altIcon: PropTypes.string,
  drawerIcon: PropTypes.string,
  expanded: PropTypes.bool,
  expandedTitle: PropTypes.string,
  isPreExpand: PropTypes.bool,
  numberOfSelectedServices: PropTypes.number,
  serviceDrawer: PropTypes.bool,
  title: PropTypes.string
}

const StyledServiceIcon = styled(ServiceIcon)`
  position: relative;
  bottom: 4px;
  margin-right: 10px;
  height: 25px;
  width: 25px;
`

const StyledIcon = styled(Icon)`
  position: relative;
  bottom: 4px;
  height: 10px;
  margin-right: 10px;
  ${props => props.condition && css`
    height: 5px;
  `}
`

const Heading = styled(Text)`
  ${Mixin.font.GothamBold(16)}
  vertical-align: 2px;
  text-transform: uppercase;
`
